import styled from "styled-components";
import { Modal, Tabs, Button } from "react-bootstrap";
import { colors, types } from "../../libs";

export const GenerateModal = styled(Modal)`
    .modal-content {
        background: transparent;
        border: none;
        box-shadow: none;
    }
    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
`;

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 24px;
    background-color: ${colors.background.lightBlack};
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    overflow-y: auto;
    max-height: 80vh;
`;

export const ModalTopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
`;

export const ModalTitleGroup = styled.div``;

export const ModalTitle = styled.div`
    ${types.body.secondaryTitle};
    color: ${colors.text.white};
    font-weight: bold;
`;

export const ModalDescription = styled.div`
    ${types.body.small};
    color: ${colors.text.gray};
    margin-top: 4px;
`;

export const CloseBtn = styled.button`
    background: transparent;
    border: none;
    color: ${colors.text.disabled};
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 1;
    border-radius: 6px;
    transition: color 0.15s ease, background 0.15s ease;
    &:hover {
        color: ${colors.text.white};
        background: rgba(255, 255, 255, 0.08);
    }
`;

export const AttachTabs = styled(Tabs)`
    border: none;
    margin-bottom: 20px;
    .nav-item {
        margin: 0 4px 0 0;
    }
    .nav-link {
        ${types.body.normal};
        color: ${colors.text.white};
        border: 1px solid ${colors.background.lightWhite} !important;
        border-radius: 6px;
        padding: 6px 18px;
        &.active {
            border: none !important;
            color: ${colors.text.green};
            background: ${colors.background.formField};
        }
        &:hover:not(.active) {
            background: ${colors.background.lightWhite};
            color: ${colors.text.white};
        }
    }
`;

export const SectionTitle = styled.div`
    ${types.body.label};
    color: ${colors.text.disabled};
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 10px;
`;

export const SectionBlock = styled.div`
    margin-bottom: 20px;
`;

export const EmptyText = styled.p`
    ${types.body.normal};
    color: ${colors.text.disabled};
    margin: 0;
    padding: 12px 0;
`;

export const FileRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 14px;
    background: ${colors.background.formField};
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 10px;
    margin-bottom: 8px;
`;

export const FileRowLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
`;

export const FileRowInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const FileRowName = styled.div`
    ${types.body.normal};
    font-weight: 600;
    color: ${colors.text.white};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const FileRowMeta = styled.div`
    ${types.body.small};
    color: ${colors.text.gray};
    margin-top: 2px;
`;

export const LinkBtn = styled(Button)`
    background: transparent;
    color: ${colors.text.green};
    border: 1px solid rgba(183, 248, 77, 0.4);
    font-size: 12px;
    padding: 5px 14px;
    border-radius: 6px;
    white-space: nowrap;
    flex-shrink: 0;
    &:hover {
        background: rgba(183, 248, 77, 0.1);
        color: ${colors.text.green};
        border-color: rgba(183, 248, 77, 0.7);
    }
    &:focus,
    &:active {
        background: rgba(183, 248, 77, 0.1) !important;
        color: ${colors.text.green} !important;
        border-color: rgba(183, 248, 77, 0.7) !important;
    }
`;

export const UnlinkBtn = styled(Button)`
    background: transparent;
    color: ${colors.text.error};
    border: 1px solid ${colors.text.error};
    font-size: 12px;
    padding: 5px 14px;
    border-radius: 6px;
    white-space: nowrap;
    flex-shrink: 0;
    &:hover {
        background: ${colors.background.error};
        color: ${colors.text.error};
        border-color: ${colors.text.error};
    }
    &:focus,
    &:active {
        background: ${colors.background.error} !important;
        color: ${colors.text.error} !important;
        border-color: ${colors.text.error} !important;
    }
`;

export const Divider = styled.hr`
    border-color: rgba(255, 255, 255, 0.08);
    margin: 20px 0;
`;

export const SearchWrapper = styled.div`
    position: relative;
    margin-bottom: 12px;
`;

export const SearchIconWrapper = styled.span`
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: ${colors.text.disabled};
    display: flex;
    align-items: center;
`;

export const SearchInput = styled.input`
    width: 100%;
    background: ${colors.background.smokyBlack};
    color: ${colors.text.white};
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    padding: 9px 14px 9px 40px;
    font-size: 14px;
    &:focus {
        outline: none;
        border-color: ${colors.background.green};
    }
    &::placeholder {
        color: ${colors.text.disabled};
    }
`;

export const FormGroup = styled.div`
    margin-bottom: 12px;
`;

export const FormLabel = styled.label`
    ${types.body.small};
    color: ${colors.text.disabled};
    margin-bottom: 5px;
    display: block;
`;

export const FormInput = styled.input`
    width: 100%;
    background: ${colors.background.smokyBlack};
    color: ${colors.text.white};
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    padding: 9px 14px;
    font-size: 14px;
    &:focus {
        outline: none;
        border-color: ${colors.background.green};
    }
    &::placeholder {
        color: ${colors.text.disabled};
    }
`;

export const AddHyperlinkBtn = styled(Button)`
    background: ${colors.background.green};
    color: ${colors.text.black};
    border: none;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    &:hover {
        background: ${colors.background.lightGreen};
        color: ${colors.text.black};
    }
    &:focus,
    &:active {
        background: ${colors.background.lightGreen} !important;
        color: ${colors.text.black} !important;
    }
    &:disabled {
        background: rgba(183, 248, 77, 0.3);
        color: rgba(0, 0, 0, 0.4);
        cursor: not-allowed;
    }
`;

export const HyperlinkRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    background: ${colors.background.formField};
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 10px;
    margin-bottom: 8px;
`;

export const HyperlinkInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const HyperlinkTitle = styled.div`
    ${types.body.normal};
    font-weight: 600;
    color: ${colors.text.white};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const HyperlinkUrl = styled.a`
    ${types.body.small};
    color: ${colors.text.green};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    text-decoration: none;
    margin-top: 2px;
    &:hover {
        text-decoration: underline;
        color: ${colors.text.green};
    }
`;

export const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 48px;
    color: ${colors.background.green};
`;

export const Spacer = styled.div`
    height: 20px;
`;
